module.exports = __webpack_public_path__ + "img/instagram.85b7d865.svg";